<template>
  <div class="become-client column is-one-third is-pulled-left">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteBecomeClientData(becomeClientData.id)"/>
      <b-field>
          <b-input placeholder="Заголовок" v-model="becomeClientData.title" required @change="updateBecomeClientData(becomeClientData)"></b-input>
      </b-field>
      <Editor
        :editorToolbar="customToolbar"
        placeholder="Текст информации"
        :id="'become-client-id-' + becomeClientData.id"
        v-model="text"
      />
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { VueEditor as Editor } from 'vue2-editor'

  export default {
    name: 'BecomeClient',
    data () {
      return {
        customToolbar: [
          ['link']
        ],
        text: ''
      }
    },
    props: {
      becomeClientData: {
        type: Object,
        required: true
      }
    },
    methods: {
      ...mapActions(['deleteBecomeClientData', 'updateBecomeClientData', 'deleteBecomeClientData'])
    },
    created () {
      this.text = this.becomeClientData.text
    },
    watch: {
      text (val) {
        this.becomeClientData.text = val
        this.updateBecomeClientData(this.becomeClientData)
      }
    },
    components: {Editor}
  }
</script>

<style scoped>
.become-client {
  background: #eeeeee;
  position: relative;
  margin: 20px 0px;
  padding: 25px 20px;
}

.delete-icon {
  top: 10px;
  right: 5px;
}
</style>



// WEBPACK FOOTER //
// BecomeClient.vue?b95d62e0